"use client";

import { ErrorScreen } from "@/components/ErrorScreen";

// Reported to the API log and recovered automatically when the cause is
// temporary — see lib/errorReport.ts.
export default function RootError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <ErrorScreen
      error={error}
      reset={reset}
      boundary="Root"
      backHref="/"
      backLabel="Back to home"
      backText="head back home"
    />
  );
}
